import { useEffect, useMemo, useState, Fragment } from 'react';
import { useTheme, Tab, Tabs, Tooltip } from '@mui/material';
import { PageLayout } from '../../../../PageLayout';
import { DEFAULT_TAB_SX_STYLES } from '../../../../../utils/styleHelpers';
import { TabPanel } from '../../../../Atoms/TabPanel';
import { fetchProducts } from '../../../../../store/Product';
import { ProductMapTab } from './ProductMapTab';
import { UnmappedProductTab } from './UnmappedProductTab';

export const ProductMap = () => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = useMemo(
    () => [
      {
        name: 'Product Map',
        tooltip: 'View product maps.',
        component: ProductMapTab
      },
      {
        name: 'Unmapped RPM Products',
        tooltip: 'View unmapped RPM products.',
        component: UnmappedProductTab
      }
    ],
    []
  );

  useEffect(() => {
    // Load all products from Product store
    fetchProducts();
  }, []);

  return (
    <PageLayout
      className="w-full mt-0"
      dataTestId="product-map-page"
      dataCy="product-map-page-card"
      pageTitle="">
      <Fragment>
        <Tabs
          sx={DEFAULT_TAB_SX_STYLES}
          value={selectedTab}
          scrollButtons="auto"
          onChange={(_e, index) => {
            setSelectedTab(index);
          }}
          slotProps={{
            indicator: {
              sx: {
                backgroundColor: theme.palette.primary.main,
                height: 2,
                borderRadius: 1
              }
            }
          }}>
          {tabs.map((tab, _index) => (
            <Tab
              sx={{
                color: 'grey9',
                fontSize: '.8rem',
                textTransform: 'none'
              }}
              key={tab.name}
              label={
                <Tooltip
                  title={<span style={{ whiteSpace: 'pre-line' }}>{tab.tooltip}</span>}
                  slotProps={{
                    tooltip: {
                      sx: {
                        maxWidth: 'none',
                        width: 'auto'
                      }
                    }
                  }}>
                  <span>{tab.name}</span>
                </Tooltip>
              }
            />
          ))}
        </Tabs>
      </Fragment>
      {tabs.map((tab, index) => (
        <TabPanel
          key={tab.name}
          value={selectedTab}
          index={index}>
          <tab.component />
        </TabPanel>
      ))}
    </PageLayout>
  );
};
